import React from 'react'
import PropTypes from 'prop-types'
import GroupsEstimateForm from './groups-estimate-form'

class EstimateForm extends React.Component {
  render = () => {
    return <GroupsEstimateForm
      defaultEstimate={this.props.defaultEstimate}
      onSubmit={this.props.onSubmit}
      isSubmitting={this.props.isSubmitting}
      preview={this.props.preview}
    />
  }
}

EstimateForm.propTypes = {
  defaultEstimate: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired
}
export default EstimateForm
